// tslint:disable
export enum PlanType {
    /**
     * @description Home Health
     */
    HMHEALTH = 19,
    /**
     * @description Auto Injury Plan
     */
    AUTOINJ = 21,
    /**
     * @description Commercial Plan
     */
    COMMPL = 22,
    /**
     * @description Federal Employee Program
     */
    FEDPL = 23,
    /**
     * @description Medicaid
     */
    MEDAD = 24,
    /**
     * @description Medicare Advantage
     */
    MDCRAD = 25,
    /**
     * @description Medicare B
     */
    MDCRB = 26,
    /**
     * @description Medicare D
     */
    MDCRD = 27,
    /**
     * @description Medi-Gap
     */
    MDGP = 28,
    /**
     * @description VA/DoD/TRICARE
     */
    VATC = 29,
    /**
     * @description Workers Compensation
     */
    WRKCMP = 30,
    /**
     * @description Plan
     */
    PLAN = 31,
    /**
     * @description Durable Medical Equiqment Plan
     */
    DMEP = 33,
    /**
     * @description Managed Care Medicaid Plan
     */
    MCMP = 34,
    /**
     * @description State Pharmacy Assistance Program
     */
    SPAP = 35,
    /**
     * @description Medicare Part A&B Plan
     */
    MEDAB = 36,
    /**
     * @description Aids Drug Assistance Program
     */
    ADAP = 37,
    /**
     * @description State Plan
     */
    STPL = 38,
    /**
     * @description Exclusive Provider Organization
     */
    EPO = 40,
    /**
     * @description Indemnity Insurance
     */
    INDEM = 41,
    /**
     * @description Health Maintenance Organization
     */
    HMO = 42,
    /**
     * @description Point of Service Plan
     */
    POSP = 43,
    /**
     * @description Preferred Provider Organization
     */
    PPO = 44,
    /**
     * @description Medicare A
     */
    MDCRA = 48,
    /**
     * @description Secondary/Supplemental
     */
    SecSupp = 54,
    /**
     * @description Employee
     */
    Employee = 63,
    /**
     * @description Dual Eligible Plan
     */
    DualEligiblePlan = 64,
}
(PlanType as any)['SECSUPP'] = 54;
(PlanType as any)['EMPLOYEE'] = 63;
(PlanType as any)['DUALELIGIBLEPLAN'] = 64;
